import _extends from "@babel/runtime/helpers/extends";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Fragment, memo } from "react";
import { sizes } from "../../../constants/spacing";
import { Checkbox } from "../../checkbox";
import { StyledOption } from "./StyledOption";
const StyledMultiSelectCheckbox = /*#__PURE__*/memo(styled(Checkbox)`
    margin-right: ${sizes.xSmall}px;
    vertical-align: middle;
`);
const noopClickHandler = () => {
  // Nothing here intentionally - the Checkbox is purely presentational.
  // Its state is controlled by its parents.
};

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const CheckboxOption = props => {
  const {
    checkedState,
    children,
    isDisabled,
    isFocused,
    isSelected
  } = props;
  return jsx(StyledOption, _extends({
    className: props.className,
    ref: props.innerRef
    // TODO optionHeight should be moved to the LayoutContext.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    ,
    height: props.selectProps.optionHeight,
    isDisabled: isDisabled,
    isFocused: isFocused,
    isSelected: isSelected
  }, props.innerProps), jsx(Fragment, null, jsx(StyledMultiSelectCheckbox, {
    "aria-hidden": true,
    tabIndex: -1,
    checkedState: checkedState,
    isDisabled: isDisabled,
    onClick: noopClickHandler
  }), children));
};
//# sourceMappingURL=CheckboxOption.js.map